import {CommonApiAuth} from '@threegene/common-js/auth';
const commonApiAuth = new CommonApiAuth('xdmOld');

/**
 * md5加盐加密
 * @param params           加密参数
 * @returns {*}            加密后的字符串
 */
export const md5Encrypt = function (params) {
  const {sign = ''} = commonApiAuth.md5Encryption(params) || {};
  return sign;
};

export default function (param) {
  // 合并后参数 MD5加盐加密 赋值给sign属性作为必传参数，这个项目中sign参数后端已经进行此步加密了
  // param.sign = md5Encrypt(param);
  // aes加密
  return {
    params: commonApiAuth.aesEncryption(param)
  };
}



// WEBPACK FOOTER //
// ./src/js/util/encrypt.js